module.exports = __webpack_public_path__ + "img/9791187050254.7fb571bd.jpg";